const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'local'

export const config = {
  ENVIRONMENT,

  API_URL: process.env.REACT_APP_API_URL || '/api',
  MONITOR_API_URL: process.env.REACT_APP_MONITOR_API_URL || '/api/feed-monitor',
  KIBANA_URL: process.env.REACT_APP_KIBANA_URL || '/kibana',
  ARTIFACTS_URL: process.env.REACT_APP_ARTIFACTS_URL || '/serve/artifacts',

  KIBANA_DASHBOARD_ID: process.env.REACT_APP_KIBANA_DASHBOARD_ID || 'e5a0ff8d-84e9-4a89-b576-fcf52cbb95f',

  ENABLE_DB_CHECK: process.env.REACT_APP_ENABLE_DB_CHECK === 'true',
  ENABLE_IMAGE_VALIDATION: process.env.REACT_APP_ENABLE_IMAGE_VALIDATION === 'true',

  DEBUG: process.env.REACT_APP_DEBUG === 'true' || ENVIRONMENT === 'local',
}

export default config
